/**
 * Application configuration
 * Environment and app configuration
 */

import { GameConfig } from '../types/GameTypes';

// Configuration interface
export interface Config {
  appVersion: string;
  isProduction: boolean;
  storageKeys: {
    dailyState: string;
    persistentState: string;
    currentGameState: string;
    userSettings: string;
  };
  dailyRefDate: string;
}

/**
 * Game configuration constants
 * Based on the original App.tsx constants
 */
export const GAME_CONFIG: GameConfig = {
  maxLetterGuesses: 6,
  defaultWordLength: 5,
  minWordLength: 5,
  maxWordLength: 10,
  rstlneLetters: ['R', 'S', 'T', 'L', 'N', 'E'],
  dailyModeTransitionDelay: 2500 // Increased from 2000ms for better user experience
};

/**
 * Application configuration implementation
 */
export const config: Config = {
  appVersion: '2.0.0',
  isProduction: process.env.NODE_ENV === 'production',
  storageKeys: {
    dailyState: 'rstlne_daily_state',
    persistentState: 'rstlne_persistent_state',
    currentGameState: 'rstlne_current_game',  // Fixed: matches original key exactly
    userSettings: 'rstlne_user_settings'
  },
  dailyRefDate: '2025-05-03T00:00:00' // Fixed: matches original reference date
};

export default config;
